import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController } from 'ionic-angular';
import { AccountProvider } from '../../providers/account/account';
import { AwsProvider } from '../../providers/aws/aws';

declare var google: any;

@IonicPage()
@Component({
  selector: 'page-edit-user',
  templateUrl: 'edit-user.html',
})
export class EditUserPage {

	userRecord: object;
  cognitoId: string;
  fields: Array<any>;
  formData: object = {};
  showSpinner: boolean;
  showPassword: boolean;
  errorMessages: Array<string> = [];
  showSuccess: boolean;

  GoogleAutocomplete = new google.maps.places.AutocompleteService();
  geocoder = new google.maps.Geocoder;
  locationAutocompleteItems = [];
  industryAutocompleteItems = [];
  agentAutocompleteItems = [];

  blockLocations: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public accountPro: AccountProvider, public aws: AwsProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
  	// null in position 1 of each array means the field will not be validated.
  	// industry and agent get validated in their custom select functions.
  	// Position 2 contains the custom validation message for that field.
  	this.fields = [
  		['firstName', 'text', 'First name can not be blank.'],
  		['lastName', 'text', 'Last name can not be blank.'],
  		['cellPhone', 'number', 'Invalid cell phone number (ex. (555) 555-5555).'],
  		['email', 'email', 'Invalid email (ex. abc@123.com).'],
  		['companyName', null, null],
  		['url', null, null],
  		['vertical', null, null],
  		['agent', null, null],
  		['street', null, null],
  		['street2', null, null],
  		['city', null, null],
  		['state', null, null],
  		['zip', null, null],
  		['companyPhone', 'number', 'Invalid company phone number (ex. (555) 555-5555).'],
  	];
		this.showSpinner = false;
		this.blockLocations = true;
		this.userRecord = this.navParams.get('userRecord');
    this.cognitoId = this.navParams.get('cognitoId');
		this.resetForm();
    this.populateIndustries();
    this.populateAgents();
    console.log('preselectinv');
  }

  /**
   * Clear out all form fields and the form error messages
   */
  resetForm() {
  	this.showPassword = false;
    this.errorMessages = [];
    this.showSuccess = false;
    for (var i in this.fields) {
      this.formData[this.fields[i][0]] = '';
    }
    this.formData['firstName'] = this.userRecord['firstName'] ? this.userRecord['firstName'] : "";
  	this.formData['lastName'] = this.userRecord['lastName'] ? this.userRecord['lastName'] : "";
  	this.formData['cellPhone'] = this.userRecord['cellPhone'] ? this.removePlus1(this.userRecord['cellPhone']) : "";
  	this.formData['email'] = this.userRecord['email'] ? this.userRecord['email'] : "";
  	this.formData['companyName'] = this.userRecord['companyName'] ? this.userRecord['companyName'] : "";
  	this.formData['url'] = this.userRecord['companyUrl'] ? this.userRecord['companyUrl'] : "";
  	this.formData['vertical'] = this.userRecord['vertical'] ? this.userRecord['vertical'] : "";
  	this.formData['agent'] = [];
  	this.formData['street'] = this.userRecord['companyAddress'] ? this.userRecord['companyAddress'] : "";
  	this.formData['street2'] = this.userRecord['companyAddress2'] ? this.userRecord['companyAddress2'] : "";
  	this.formData['city'] = this.userRecord['companyCity'] ? this.userRecord['companyCity'] : "";
  	this.formData['state'] = this.userRecord['companyState'] ? this.userRecord['companyState'] : "";
  	this.formData['zip'] = this.userRecord['companyZip'] ? this.userRecord['companyZip'] : "";
  	this.formData['companyPhone'] = this.userRecord['companyPhone'] ? this.removePlus1(this.userRecord['companyPhone']) : "";
  }

	/**
   * Whenever the field is entered by the user, this function will run
   */
  locationFocus() {
    this.blockLocations = false;
  }

  updateLocationSearchResults(text: string) {
    if (!text || text == '') {
      this.locationAutocompleteItems = [];
    } else {
      this.GoogleAutocomplete.getPlacePredictions({
        input: text,
        types: ['address'],
        componentRestrictions: { country: 'us' }
      }, (predictions, status) => {
        this.locationAutocompleteItems = [];
        if (predictions) {
          predictions.forEach((prediction) => {
            this.locationAutocompleteItems.push(prediction);
          });
        }
      });
    }
  }

  selectLocationSearchResult(item) {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();this.showSpinner = true;
    this.locationAutocompleteItems = [];
    this.blockLocations = true;
    this.geocoder.geocode({ 'placeId': item.place_id }, (results, status) => {
      if (status == 'OK' && results[0]) {
        for (let component of results[0]['address_components']) {
          if (component['types'].indexOf('street_number') > -1) {
            this.formData['street'] = component['short_name'];
          } else if (component['types'].indexOf('route') > -1) {
            this.formData['street'] += ' ' + component['short_name'];
          } else if (component['types'].indexOf('locality') > -1) {
            this.formData['city'] = component['short_name'];
          } else if (component['types'].indexOf('administrative_area_level_1') > -1) {
            this.formData['state'] = component['short_name'];
          } else if (component['types'].indexOf('postal_code') > -1) {
            this.formData['zip'] = component['short_name'];
          }
        }
      }
      setTimeout(() => {
        this.showSpinner = false;
      }, 10);
    })
    loading.dismiss();
  }

  populateIndustries() {
    this.accountPro.getVerticals()
      .then((results) => {
        if (results) {
          this.industryAutocompleteItems = [];
          results['verticals'].forEach((result) => {
            this.industryAutocompleteItems.push(result);
          });
          console.log("This is industryAutocompleteItems: ", this.industryAutocompleteItems);
        };
      });
  }

  selectIndustrySearchResult(item) {
		item = item.trim();
    console.log("item in selectIndustrySearchResult");
    console.log(item);
    var obj: object;
    for (var i = 0; i < this.industryAutocompleteItems.length; i++) {
      if (item == this.industryAutocompleteItems[i]['label'].trim()) {
        obj = this.industryAutocompleteItems[i];
        break;
      }
    }
    if (obj) {
      this.formData['vertical'] = obj['vertical'];
      this.formData['verticalLabel'] = obj['label'];
    } else {
      this.errorMessages.push('Oops! Something went wrong with selecting your industry. Please try again.');
    }
  }

  populateAgents() {
    this.accountPro.getAgents()
      .then((results) => {
        if (results) {
          this.agentAutocompleteItems = [];
          results.forEach((result) => {
            this.agentAutocompleteItems.push(result);
          }
          );
          this.preSelectAgent();
        };
      });
  }

  /**
   * Run when data is loaded from the database, this removes +1 from phone numbers
   */
  removePlus1(phoneNumber){
    if(phoneNumber.indexOf("+1") === 0){
      phoneNumber = phoneNumber.slice(2);
    }
    return phoneNumber;
  }

  /**
   * Select agent
   */
  selectAgent(selected, agent) {
    if(this.formData['agent'] === 'No Agent') {
        this.formData['agent'].splice(0, 1);
    }
    if (selected['classList'].contains('selected')) {
      selected['classList'].remove('selected');
      this.formData['agent'].splice(this.formData['agent'].indexOf(agent),1);
    } else if (this.formData['agent'].indexOf(agent) === -1){
      this.formData['agent'].push(agent);
      selected['classList'].add('selected');
    };
  }

  preSelectAgent() {
    if(this.userRecord['agencyUserIds']) {
      for(let agency of this.agentAutocompleteItems) {
        let index = this.userRecord['agencyUserIds'].indexOf(agency.objectId);
        if(index > -1){
          this.formData['agent'].push(agency)
        }
      }
    }
  }

  checkAgentSelected(objectId) {
    if(this.userRecord['agencyUserIds']) {
      let index = this.userRecord['agencyUserIds'].indexOf(objectId);
      if(index > -1){
        return true;
      } else return false;
    }
  }
  /**
   * Run whenever the number field is changed, this autoformats US
   * phone numbers
   */
  numberChanged(numberField: string) {
    try {
      const number: string = this.formData[numberField].match(/\d+/g).join('');
      if (number.length > 0 && number.length < 3) {
        this.formData[numberField] = '(' + number;
      } else if (number.length > 2 && number.length < 5) {
        this.formData[numberField] = '(' + number.slice(0, 3) + ') ' + number.slice(3);
      } else if (number.length) {
        this.formData[numberField] = '(' + number.slice(0, 3) + ') ' + number.slice(3, 6) + '-' + number.slice(6);
      }
    } catch (error) { }
  }

	/**
   * Check each field for validity, collect error messages for all bad fields,
   * returns true if entire form is valid, false otherwise.
   */
  isFormValid() {
    var valid: boolean = true;
    for (var i = 0; i < this.fields.length; i++) {
      if(this.fields[i][1] !== null){
	      var fieldData: Array<string> = this.fields[i];
	      var result: boolean = this.isFieldValid(fieldData);
        if (!result) { // invalid field
	        valid = false;
	      }
	    }
    }
    return valid;
  }

  /**
   * Check if a field is valid, returns true if it is and false + adds error
   * message to array if it is not
   * @param {String} field  field name to check validity of
   */
  isFieldValid(field: Array<string>) {

    if (field[1] == 'text') {
      if (this.validateTextInput(field[0])) {
        return true;
      } else {
      	this.errorMessages.push(field[2]);
        return false;
      }
    }

    else if (field[1] == 'number') {
      if (this.validatePhoneNumber(field[0])) {
        return true;
      } else {
      	this.errorMessages.push(field[2]);
        return false;
      }
    }

    else if (field[1] == 'email') {
      if (this.validateEmail(field[0])) {
        return true;
    	}else{
    		this.errorMessages.push(field[2]);
    		return false;
    	}
    }

    else if (field[1] == 'url') {
      if (this.validateURL()) {
        return true;
      } else {
        this.errorMessages.push(field[2]);
        return false;
      }
    }

    else if (field[1] == 'state') {
      if (this.validateState()) {
        return true;
      } else {
        this.errorMessages.push(field[2]);
        return false;
      }
    }
    else if (field[1] == 'zip') {
      if (this.validateZip()) {
        return true;
      } else {
        this.errorMessages.push(field[2]);
        return false;
      }
    }
  }

  validateTextInput(field: string) {
    return this.formData[field].trim().length > 0;
  }

  validatePhoneNumber(field: string) {
    try {
      const number: string = this.formData[field].match(/\d+/g).join('');
      return number.length == 10;
    } catch (error) {
      return false;
    }
  }

  validateEmail(field: string) {
    var amp = this.formData[field].indexOf('@');
    var domain = this.formData[field].lastIndexOf('.');
    var emailLength = this.formData[field].length;
    if ((amp != -1) && (domain > amp) && (domain + 1 < emailLength)) {
    	return true;
    } else {
    	return false;
    }
  }

  validateURL() {
    var url: string = this.formData['url'].trim();
    var valid: boolean = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(url);
    return valid;
  }

  validateState() {
    return this.formData['state'].trim().length == 2;
  }

  validateZip() {
    return this.formData['zip'].trim().length == 5;
  }

  submit() {
  	this.errorMessages = [];
    if (this.isFormValid()) {
      console.log("validated");
      this.showSpinner = true;
      this.errorMessages = [];
      this.editAccount();
    } else {
      console.log("not valid");
    	this.showSuccess = false;
    }
  }

  // Get the domain out of the url
  getDomain(url){
    let start = 0;
    let protocol = url.indexOf("://");
    if(protocol !== -1){
      start = protocol + 3;
      url = url.substring(start);
    }
    let slash = url.indexOf("/");
    if(slash !== -1){
      url = url.substring(0, slash);
    }
    let lastDot = url.lastIndexOf(".");
    let prevDot = url.lastIndexOf(".", lastDot-1);
    if(prevDot !== -1){
      url = url.substring(prevDot+1);
    }
    return url;
  }

  // Need to use remove to remove empty attributes. Create 2 objects within data: update & remove.
  // If a field is empty, or doesn't exist, it goes in the remove object.
  editAccount() {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    var data: object = {
    	'cognitoId': this.cognitoId,
      'firstName': this.formData['firstName'].trim(),
      'lastName': this.formData['lastName'].trim(),
      'cellPhone': '+1' + this.formData['cellPhone'].match(/\d+/g).join(''),
      'email': this.formData['email'].trim()
    };
    console.log('formdata agent ', this.formData['agent']);

    if(this.userRecord['companyName'] && this.formData['companyName'] == ''){ data['companyName'] = null; }
    else if (this.formData['companyName']){ data['companyName'] = this.formData['companyName'].trim() };

    if(this.userRecord['companyUrl'] && this.formData['url'] == '') {
      data['companyUrl'] = null;
      data['domain'] = null;
    } else if(this.formData['url']){
      data['companyUrl'] = this.formData['url'].trim();
      data['domain'] = this.getDomain(data['companyUrl']);
    };

    if(this.userRecord['vertical'] && this.formData['vertical'] == '') { data['vertical'] = null; }
    else if (this.formData['vertical']){ data['vertical'] = this.formData['vertical'].trim() };

    if(this.userRecord['agent'] && this.formData['agent'] == '') { data['agent'] = null; }
    else if (this.formData['agent']){ data['agent'] = this.formData['agent'] };

    if(this.userRecord['companyAddress'] && this.formData['street'] == '') { data['companyAddress'] = null; }
    else if (this.formData['street']){ data['companyAddress'] = this.formData['street'].trim() };

    if(this.userRecord['companyAddress2'] && this.formData['street2'] == '') { data['companyAddress2'] = null; }
    else if (this.formData['street2']){ data['companyAddress2'] = this.formData['street2'].trim() };

    if(this.userRecord['companyCity'] && this.formData['city'] == '') { data['companyCity'] = null; }
    else if (this.formData['city']){ data['companyCity'] = this.formData['city'].trim() };

    if(this.userRecord['companyState'] && this.formData['state'] == '') { data['companyState'] = null; }
    else if (this.formData['state']){ data['companyState'] = this.formData['state'].trim() };

    if(this.userRecord['companyZip'] && this.formData['zip'] == '') { data['companyZip'] = null; }
    else if (this.formData['zip']){ data['companyZip'] = this.formData['zip'].trim() };

    if (this.formData['companyPhone']){ data['companyPhone'] = this.formData['companyPhone'].trim().match(/\d+/g).join('') };

    console.log("data going to the lambda:");
    console.log(data);
    return this.accountPro.editAccount(data)
      .then((result) => {
        loading.dismiss();
        this.showSpinner = false;
        if (result['success']) {
          //this.showSuccess = true;
          let msg = result['message'] || 'The user account has been edited.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        } else {
        	this.errorMessages.push(result['message']);
        	//this.showSuccess = false;
          let msg = result['message'] || 'Error editing user record. Please try again.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/edit-user/edit-user.ts